export class Shipping {
  static findShippingCost (itemName: string, quantity: number): number {
    const isShirt = (itemName === 't-shirt-united-athle-5001') || (itemName === 'long-sleeve-t-shirt-united-athle-5011')

    if (isShirt && quantity === 1) {
      // フロントで返す送料は税込
      return 385
    } else {
      return 770
    }
  }
}
